import Component from '@glimmer/component';

import queue from '@nullvoxpopuli/ember-composable-helpers/helpers/queue';
import { hash } from '@ember/helper';
import { Input } from '@ember/component';

import CButton from 'rise-ui/components/c-button.gjs';
import CIdentity from 'rise-ui/components/c-identity.gjs';
import DropdownButton from 'rise-ui/components/dropdown-button.gjs';
import event from 'rise-ui/helpers/event.js';
import fnx from 'rise-ui/helpers/fnx.js';
import one from 'rise-ui/helpers/one.js';
import or from 'rise-ui/helpers/or.js';
import neq from 'rise-ui/helpers/neq.js';
import not from 'rise-ui/helpers/not.js';
import set from 'rise-ui/helpers/set.js';
import enter from 'rise-ui/modifiers/enter.js';
import focus from 'rise-ui/modifiers/focus.js';

export default class DropdownPromptComponent extends Component {
  <template>
    {{#let (one this.responseInput @response) as | response |}}
    <DropdownButton
      @disabled={{@disabled}}
      @side={{or @side "bottom-start"}}
      @title={{neq (or @title @text "Enter Value") (or @text "Enter Value")}}
      ...attributes
      as | ddb |
    >
      <ddb.button>{{or @text "Enter Value"}}</ddb.button>
      <ddb.body>
        {{#let (queue ddb.submit (fnx @onSubmit response)) as | onSubmit |}}
        <label>
          {{or @prompt "Value"}}:
          <Input
            placeholder={{@placeholder}}
            @value={{readonly response}}
            oninput={{event (queue (set this "responseInput") (fnx @onResponse response))}}
            {{focus}}
            {{enter onSubmit}}
          />
        </label>
        <CButton
          @type="small primary"
          @disabled={{not response}}
          @title={{neq (one @submitText @title @text "OK") (one @submitText "OK")}}
          @action={{onSubmit}}
        >
          {{one @submitText "OK"}}
        </CButton>
        {{/let}}
        {{yield (hash
          body=(component CIdentity)
          cancel=ddb.cancel
          submit=ddb.submit
        )}}
      </ddb.body>
    </DropdownButton>
    {{/let}}
  </template>
}
